/* eslint-disable react-hooks/exhaustive-deps */
/**
 * @file timelineItem
 * @description 时间线
 * @author jc
 */
import React, { Fragment, useCallback, useState } from 'react';
import OutlinedDown from 'acud-icon/lib/icons/OutlinedDown';
import OutlinedUp from 'acud-icon/lib/icons/OutlinedUp';
import cls from 'classnames';
import { ConfigContext } from '../config-provider';
const TimelineItem = ({ prefixCls: customizePrefixCls, color, label, dot, content, status = 'default', onClick, render, className, children, lineColor }) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('timeline-item', customizePrefixCls);
    const PRE_HEAD_FIX = `${prefixCls}-head`; // 头部圆点
    const PRE_HEAD_LINE = `${prefixCls}-line`; // 线条
    const PRE_CONTENT_FIX = `${prefixCls}-content`; // 内容
    const PRE_CONTENT_LABEL_FIX = `${PRE_CONTENT_FIX}-label`; // 内容标签
    const PRE_CONTENT_TITLE_FIX = `${PRE_CONTENT_FIX}-title`; // 内容标题
    const PRE_CONTENT_LINK_FIX = `${PRE_CONTENT_FIX}-link`; // 展开按钮
    const PRE_CONTENT_LINK_LABEL_FIX = `${PRE_CONTENT_LINK_FIX}-label`; // 展开按钮文案
    const PRE_CONTENT_INNER_FIX = `${prefixCls}-content-inner`; // 内容
    const PRE_CONTENT_APPEND_FIX = `${prefixCls}-content-append`; // 可展开的内容
    const PRE_RENDER_FIX = `${prefixCls}-render`; // 客制化渲染border
    const PRE_RENDER_DTLBTN_FIX = `${PRE_RENDER_FIX}-dtlbtn`; // 查看详情按钮
    const [isAppend, updateIsAppend] = useState(false); // 展开/收起
    const renderHead = useCallback(() => {
        let statusClass = '';
        if (dot) {
            statusClass = `dot-${status}`;
            return <div className={`${PRE_HEAD_FIX} ${statusClass} is-dot`}>{dot}</div>;
        }
        statusClass = `is-${status}`;
        let statusStyle = {};
        if (color) {
            statusStyle = { backgroundColor: color };
        }
        const props = {
            className: cls(PRE_HEAD_FIX, statusClass),
            style: statusStyle
        };
        return <div {...props}></div>;
    }, [status, dot, color]);
    // 展示更多-按钮
    const renderAppend = useCallback(() => {
        if (!content) {
            return;
        }
        return (<a className={PRE_CONTENT_LINK_FIX} onClick={() => updateIsAppend(!isAppend)}>
                <span className={PRE_CONTENT_LINK_LABEL_FIX}>{isAppend ? '收起' : '展开'}</span>
                {isAppend ? <OutlinedUp /> : <OutlinedDown />}
            </a>);
    }, [isAppend]);
    // 可展开内容
    const renderAppendContent = () => {
        const innerClass = `${PRE_CONTENT_APPEND_FIX} ${PRE_CONTENT_INNER_FIX}${isAppend ? ' is-shadow' : ' is-hidden'}`;
        return <div className={innerClass}>{content}</div>;
    };
    // 默认内容
    const renderContent = () => <div className={PRE_CONTENT_INNER_FIX}>{content}</div>;
    // 渲染函数
    const renderItem = () => {
        if (render) {
            return (<div className={PRE_RENDER_FIX}>
                    {render()}
                    <a className={PRE_RENDER_DTLBTN_FIX} onClick={onClick}>
                        查看详情
                    </a>
                </div>);
        }
        return (<Fragment>
                {label && <div className={PRE_CONTENT_LABEL_FIX}>{label}</div>}
                <div className={PRE_CONTENT_TITLE_FIX}>{children}</div>
                {renderAppend()}
                {content && renderAppendContent()}
                {!content && renderContent()}
            </Fragment>);
    };
    const withDotClass = dot ? 'with-dot' : '';
    const classes = cls(prefixCls, dot ? 'is-dot' : '', className);
    return (<div className={classes}>
            <span className={PRE_HEAD_LINE} style={{ background: `${lineColor}` }}></span>
            {renderHead()}
            <div className={cls(PRE_CONTENT_FIX, withDotClass)}>{renderItem()}</div>
        </div>);
};
export default TimelineItem;
